import constants from '../../common/constants/CommonConstants';
import {
  deleteScoreSettings,
  fetchCriteriaSettings,
  fetchScoreSettings,
  reorderScoreSettings,
  saveCriteriaSettings,
  saveScoreSettings,
} from '../routines/healthRoutines';

const DEFAULT_CRITERIA_SETTINGS = { lowerBound: 4, upperBound: 7 };

const initialState = {
  isLoading: false,
  isSaving: false,
  criteriaSettings: {
    [constants.ORGANIZATION_LEVEL]: DEFAULT_CRITERIA_SETTINGS,
    [constants.ACCOUNT_LEVEL]: DEFAULT_CRITERIA_SETTINGS,
    [constants.CONTACT_LEVEL]: DEFAULT_CRITERIA_SETTINGS,
  },
  scoreSettings: {
    [constants.ORGANIZATION_LEVEL]: [],
    [constants.ACCOUNT_LEVEL]: [],
    [constants.CONTACT_LEVEL]: [],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case fetchScoreSettings.TRIGGER:
    case fetchCriteriaSettings.TRIGGER:
    case reorderScoreSettings.TRIGGER:
    case deleteScoreSettings.TRIGGER:
      return { ...state, isLoading: true };
    case saveScoreSettings.TRIGGER:
    case saveCriteriaSettings.TRIGGER:
      return { ...state, isSaving: true };
    case fetchScoreSettings.SUCCESS: {
      const { level, scoreSettings } = action.payload;
      return {
        ...state,
        isLoading: false,
        scoreSettings: {
          ...state.scoreSettings,
          [level]: scoreSettings,
        },
      };
    }
    case fetchCriteriaSettings.SUCCESS: {
      const {
        level,
        criteriaSettings: { config },
      } = action.payload;
      return {
        ...state,
        isLoading: false,
        criteriaSettings: {
          ...state.criteriaSettings,
          [level]: config || DEFAULT_CRITERIA_SETTINGS,
        },
      };
    }
    case reorderScoreSettings.SUCCESS:
    case deleteScoreSettings.SUCCESS:
      return { ...state, isLoading: false };
    case saveScoreSettings.SUCCESS:
    case saveCriteriaSettings.SUCCESS:
      return { ...state, isSaving: false };
    case fetchScoreSettings.FAILURE:
    case fetchCriteriaSettings.FAILURE:
    case reorderScoreSettings.FAILURE:
    case deleteScoreSettings.FAILURE:
      return { ...state, isLoading: false };
    case saveScoreSettings.FAILURE:
    case saveCriteriaSettings.FAILURE:
      return { ...state, isSaving: false };
    default:
      return state;
  }
};
